/**
 * Fallback default value
 */
function defaultTo(valueArg, defaultValue) {
    const value = valueArg;
    return value == null || value !== valueArg ? defaultValue : value;
}

/**
 * Formats an amount in cents into a currency string using a specified or default format.
 *
 * @param {number|string} centsArg - The amount in cents.
 * @param {string} [formatArg] - Optional format string. Defaults to `window.theme.settings.money_format`.
 * @returns {string} Formatted currency string.
 *
 * The function supports formatting with or without decimals, and with different separators.
 * Examples of format placeholders: `amount`, `amount_no_decimals`, `amount_with_comma_separator`.
 */
function formatMoney(centsArg, formatArg) {
    let cents = centsArg;
    let format = formatArg;
    if (!format) {
        format = window.theme.settings.money_format;
    }

    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format;

    function formatWithDelimiters(numberArg, precisionArg, thousandsArg, decimalArg) {
        let number = numberArg;
        let precision = precisionArg;
        let thousands = thousandsArg;
        let decimal = decimalArg;

        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');

        if (Number.isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        default:
            value = formatWithDelimiters(cents, 2);
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

export {formatMoney};